<template>
  <v-dialog v-model="dialog" max-width="700" persistent transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat dark color="secondary">
          <v-toolbar-title>Informasi</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pa-0 ma-0">
        <v-list three-line>
          <v-list-item>
            <v-list-item-avatar size="80">
              <v-avatar class="red lighten-4" size="80">
                <v-icon dark style="font-size: 2.5rem" class="red--text">
                  mdi-alert
                </v-icon>
              </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
              <h3 class="mb-2">Data DAPODIK Tidak Sesuai</h3>
              <p class="body-2 text-justify mb-2">
                Data Anda saat ini yang terhubung dengan <strong>DAPODIK belum sesuai.</strong> Segera lakukan
                <strong>Pembaruan Data</strong> Anda sesuai data terbaru Anda
              </p>
              <p class="body-2 text-justify mb-2">
                Anda dapat melakukan perubahan data dapodik melalui <strong>Operator Sekolah</strong> atau
                <strong>Operator Dinas</strong>. Apabila data sudah termutakhirkan di dapodik maka otomatis data di
                SIMPKB akan ikut berubah.
              </p>
              <p class="body-2 text-justify mb-2">
                Estimasi waktu update di dapodik adalah <strong>2 x 24 jam</strong> setelah operator dinas melakukan
                perubahan
              </p>
              <div class="mt-4">
                <label class="red--text">Kirim catatan kesalahan data Anda</label>
                <v-textarea
                  outlined
                  class="mt-1"
                  placeholder="Tuliskan catatan data Anda yang tidak sesuai dengan data DAPODIK"
                  v-model="form['catatan_salah']"
                ></v-textarea>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="text-right">
          <v-btn color="info" elevation="0" @click="save">Kirim</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'PopupDaftarLapor',
  props: {
    params: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      form: {},
    };
  },
  methods: {
    ...mapActions('preferensi', ['ajuan']),

    open() {
      this.$set(this, 'form', {});
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    save() {
      const params = Object.assign({}, this.params, this.form);

      this.ajuan({ params }).then(() => {
        this.$emit('reload');
        this.close();
      });
    },
  },
};
</script>
